const CAPABILITY_KEY = "stratify.deletion.capability";
const JOB_KEY = "stratify.deletion.jobId";
const IDEMPOTENCY_PREFIX = "stratify.deletion.idempotency.";

export function deletionIdempotencyKeyForUid(uid) {
  if (!uid) return null;
  const storageKey = `${IDEMPOTENCY_PREFIX}${uid}`;
  try {
    const existing = localStorage.getItem(storageKey);
    if (existing) return existing;
    const next =
      typeof crypto !== "undefined" && crypto.randomUUID
        ? crypto.randomUUID()
        : `del-${Date.now()}-${Math.random().toString(16).slice(2)}`;
    localStorage.setItem(storageKey, next);
    return next;
  } catch {
    return `del-${Date.now()}`;
  }
}

export function persistDeletionReceipt({ jobId, deletionCapability }) {
  try {
    if (deletionCapability) localStorage.setItem(CAPABILITY_KEY, deletionCapability);
    if (jobId) localStorage.setItem(JOB_KEY, jobId);
  } catch {
    /* ignore quota */
  }
}

export function readDeletionReceipt() {
  try {
    return {
      deletionCapability: localStorage.getItem(CAPABILITY_KEY),
      jobId: localStorage.getItem(JOB_KEY),
    };
  } catch {
    return { deletionCapability: null, jobId: null };
  }
}

export function clearDeletionReceipt() {
  try {
    localStorage.removeItem(CAPABILITY_KEY);
    localStorage.removeItem(JOB_KEY);
  } catch {
    /* ignore */
  }
}

export function hasDeletionReceipt() {
  const receipt = readDeletionReceipt();
  return Boolean(receipt.deletionCapability || receipt.jobId);
}
